export const ProductStatusEnum = {
    Private: 1,
    Published: 2
}
Object.freeze(ProductStatusEnum);